import { render, staticRenderFns } from "./limitDrawer.vue?vue&type=template&id=5347c32c&scoped=true"
import script from "./limitDrawer.vue?vue&type=script&lang=js"
export * from "./limitDrawer.vue?vue&type=script&lang=js"
import style0 from "./limitDrawer.vue?vue&type=style&index=0&id=5347c32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347c32c",
  null
  
)

export default component.exports